import { createReducer } from 'typesafe-actions';
import { LipTileAction } from '@store/actions';
import { fetchLIPTileAsync } from '@store/actions/lipTile.action';

export const lipTile: any = {
    lipTileResponse: []
};

export const lipTileReducer = createReducer<any, LipTileAction>(lipTile)
    .handleAction(fetchLIPTileAsync.cancel, (state: any) => ({
        ...state,
        lipTileResponse: []
    }))
    .handleAction(fetchLIPTileAsync.success, (state: any, action: any) => ({
        ...state,
        lipTileResponse: !state.lipTileResponse.some(
            //checking if the loannumber details already exist in the state
            (x: { header: { referenceTitle: { metadata: { values: { loanNumber: any } } } } }) =>
                x.header.referenceTitle.metadata.values.loanNumber === action.payload.header.referenceTitle.metadata.values.loanNumber
        )
            ? [...state.lipTileResponse, action.payload]
            : state.lipTileResponse
    }));
